// Rich-text helpers shared by the announcement editor and the post listings that preview
// the HTML it produces.

export const stripHtml = (html) => {
  if (!html) return ''
  const tmp = document.createElement('div')
  tmp.innerHTML = html
  return (tmp.textContent || tmp.innerText || '').replace(/\s+/g, ' ').trim()
}

// Quill leaves markup behind for "empty" content (<p><br></p>), so test the text, not the HTML.
export const isEmptyHtml = (html) => stripHtml(html) === ''
